import { Drawer, Button } from "antd";
import { KYC_STATUS_LABELS, CARD_STATUS_LABELS } from "../KycUsersTable/KycUsersTableConfig";

export default function KycUsersFilterDrawer({
  filterOpen,
  setFilterOpen,
  filters,
  setFilters,
  setCurrentPage,
}) {
  const kycStatusOptions = Object.entries(KYC_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  }));
  const cardStatusOptions = Object.entries(CARD_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  }));

  const clearAll = () => {
    setFilters({ kycStatus: null, cardStatus: null });
  };

  return (
    <Drawer
      title={
        <div className="flex justify-between items-center w-full">
          <span className="text-base font-semibold text-[#171717] font-poppins">Filter</span>
          <button className="text-[#DC2626] text-sm font-semibold font-poppins bg-transparent border-0" onClick={clearAll}>
            Clear all
          </button>
        </div>
      }
      placement="right"
      open={filterOpen}
      onClose={() => setFilterOpen(false)}
      width={450}
      className="rounded-l-3xl"
    >
      {/* KYC Status */}
      <div className="mb-4">
        <p className="text-sm font-medium text-[#334155] font-poppins mb-2">KYC Status</p>
        <div className="flex flex-wrap gap-2">
          {kycStatusOptions.map((option) => (
            <button
              key={option.value}
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  kycStatus: prev.kycStatus === option.value ? null : option.value,
                }))
              }
              className={`px-4 py-2 rounded-xl border-0 text-[13px] font-semibold font-poppins transition ${
                filters.kycStatus === option.value
                  ? "bg-[#2563EB] text-white"
                  : "bg-[#EFF6FF] text-[#334155] hover:bg-[#DBEAFE]"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Card/Wallet Status */}
      <div className="mb-4">
        <p className="text-sm font-medium text-[#334155] font-poppins mb-2">Card/Wallet Status</p>
        <div className="flex flex-wrap gap-2">
          {cardStatusOptions.map((option) => (
            <button
              key={option.value}
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  cardStatus: prev.cardStatus === option.value ? null : option.value,
                }))
              }
              className={`px-4 py-2 rounded-xl border-0 text-[13px] font-semibold font-poppins transition ${
                filters.cardStatus === option.value
                  ? "bg-[#2563EB] text-white"
                  : "bg-[#EFF6FF] text-[#334155] hover:bg-[#DBEAFE]"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-start gap-4 mt-8">
        <Button
          onClick={() => {
            setFilterOpen(false);
            setCurrentPage(1);
          }}
          className="w-[45%] border-[1px] border-solid border-[#E2E8F0] rounded-xl !py-6 bg-white text-[#334155] text-base font-semibold font-poppins hover:bg-gray-50"
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="w-[45%] btn-gradient rounded-xl !py-6 border-0 text-base font-semibold font-poppins"
          onClick={() => {
            setFilterOpen(false);
            setCurrentPage(1);
          }}
        >
          Apply Filter
        </Button>
      </div>
    </Drawer>
  );
}
